import { SVGELEMENT } from '../../../../../enums/SVGELEMENT.js';
import SVGSHAPE from '../SVGSHAPE.js';
import { makeStruct } from '../../../../../enums/MODELS.js';
import { makeAttrStruct } from '../../../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../../../enums/ModelData.js';
// Model Structure
export const svgPathAttr = makeAttrStruct([
    ['d', ''],
    ['fill', 'none'], // Default fill color
    ['stroke', 'currentColor'], // Default stroke color
    ['style'],
    ['name']
]);
export const svgPathData = makeDataStruct();
export const svgPathModel = makeStruct([
    ['attributes', svgPathAttr],
    ['data', svgPathData]
]);
// Simplified Model
export function svgPath(attributes, data) {
    return {
        attributes: svgPathAttr(attributes.d, attributes.fill, attributes.stroke, attributes.style, attributes.name),
        data: svgPathData()
    };
}
/** Creates a Line Shape for an SVG */
export default class SVGPATH extends SVGSHAPE {
    constructor(node, model) {
        super(node, SVGELEMENT.PATH, model);
    }
}
